import { forwardRef } from "react";

import { Icons } from "widgets";

import { getGeneTypeColor } from "../../../../app-utils/color.js";
import { type Gene } from "../../../../graphql.js";
import { Tile, type TileProps } from "../../../../modules/core/components/Tile.js";
import { ENTITY_TYPE } from "../../../../settings/settings.js";

interface GeneTileProps extends Pick<TileProps, "type" | "footNote"> {
  gene: Gene;
  hideIcon?: boolean;
}

const GeneTile = forwardRef<HTMLDivElement, GeneTileProps>(function GeneTile(props, ref) {
  if (!props.gene) return null;

  return (
    <Tile
      title={props.gene.name}
      tags={
        props.gene.geneType
          ? [{ label: props.gene.geneType, intentColor: getGeneTypeColor(props.gene.geneType) }]
          : undefined
      }
      type={props.type !== undefined ? props.type : "Gene"}
      to={`/${ENTITY_TYPE.GENE}/${props.gene.id}`}
      icon={props.hideIcon !== true ? <img src={Icons.Tiles.Entity} width={24} height={30} /> : undefined}
      footNote={props.footNote}
      ref={ref}
    >
      {props.gene.description}
    </Tile>
  );
});

export { GeneTile };
